import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';

export interface TabBarItemProps {
  value: string;
  label: string;
  onClick: (itemValue: string) => void;
  parentValue?: string;
  disabled?: boolean;
  className?: string;
}

export const TabBarItem: FC<TabBarItemProps> = ({
  value,
  label,
  onClick,
  disabled,
  parentValue,
  className,
}) => {
  const active = parentValue === value;

  return (
    <button
      onClick={() => {
        onClick(value);
      }}
      disabled={disabled}
      role="tab"
      aria-label={`${label} tab`}
      aria-selected={active}
      className={`${active ? 'active' : ''} ${css({
        position: 'relative',
        cursor: 'pointer',
        flex: 1,
        px: 'small',
        py: 'small',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'neutrals.text_secondary',
        border: '1px solid transparent',
        borderBottomColor: 'neutrals.stroke_secondary',
        borderInlineStartColor: 'neutrals.stroke_secondary',
        '&:last-of-type': {
          borderInlineEndColor: 'neutrals.stroke_secondary',
        },

        '&.active': {
          color: 'neutrals.text_primary',
          fontWeight: '700',
          borderBottomColor: 'transparent !important',
          '&:last-of-type': {
            borderInlineStartColor: 'neutrals.stroke_secondary',
          },
        },
        '&:hover:not(:disabled)': {
          backgroundColor: 'neutrals.fill_focused',
        },
        '&:disabled': {
          userSelect: 'none',
          cursor: 'not-allowed',
          color: 'neutrals.text_disabled',
          '&:last-of-type': {
            borderInlineEndColor: 'neutrals.text_disabled',
          },
        },
      })} ${className ?? ''}`}
    >
      <span
        className={css({
          visibility: active ? 'visible' : 'hidden',
          height: '5px',
          position: 'absolute',
          top: '-1px',
          insetInline: '-1px',
          insetInlineEnd: '-1px',
          backgroundColor: 'neutrals.stroke_primary',
        })}
      />

      <span>{label}</span>
    </button>
  );
};
